@if (isLoading$ | async) {
  <div class="loading-mask">
    <div class="loader-container">
      <img ngSrc="assets/images/Loading.svg" alt="Loading..." fill priority>
    </div>

    @if (isScanning$ | async) {
      <div class="scan-loader-container">
        {{ antivirusScanStatus }}
      </div>
    }

  </div>
}
@if ((isLoggedIn$ | async) && actionDataFetched) {
    <app-navigation-bar></app-navigation-bar>
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
}